import { makeStyles, withStyles } from '@material-ui/core/styles';
import { StandardDivProps } from '@sprinx/react-mui-components/StandardDiv';
import withThemeProps from '@sprinx/react-mui-components/withThemeProps';
import clsx from 'clsx';
import React from 'react';
import { useRecoilValue } from 'recoil';
import { currencyState } from '../../../api/appState';
import { ProductDetailProduct } from '../../../api/products/productDetail';
import ProductPriceElement from '../../../components/ProductPriceElement';
import useTranslateWithFallback from '../../../hooks/useTranslateWithFallback';

export interface ProductDetailPriceProps extends StandardDivProps<ProductDetailPriceClassKey> {
  product: ProductDetailProduct;
}

export type ProductDetailPriceClassKey = 'root';

const themeSettings = { name: 'ProductDetailPrice' };
const useStyles = makeStyles(
  (/* theme */) => ({
    root: {
      display: 'flex',
      alignItems: 'flex-end',
    },
    unitPrice: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-end',
    },
    totalPrice: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-end',
    },
    inputRoot: {
      '& > label': {
        textAlign: 'right',
        transform: 'none',
        fontSize: 12,
      },
    },
    priceAlignRigth: {
      textAlign: 'right',
    },
  }),
  themeSettings,
);

const ProductDetailPrice = React.forwardRef<HTMLDivElement, ProductDetailPriceProps>(
  ({ className, classes: pClasses, product }, ref) => {
    const classes = useStyles({ classes: pClasses });
    const currency = useRecoilValue(currencyState);
    const t = useTranslateWithFallback();

    // const noZeroPackSize = product?.extra?.packSize || 1;
    // const unitPriceWithTax = product.priceWithTax ? product.priceWithTax / noZeroPackSize : product.priceWithTax;
    // const unitPrice = product.price ? product.price / noZeroPackSize : product.price;

    const priceSaleWithTax = product.salePriceWithTax?.find((pl) => pl.currency === currency)?.amount;

    return (
      <div ref={ref} className={clsx(classes.root, className)}>
        {/* {unitPrice != product.price && (
          <div className={clsx(classes.unitPrice, className)}>
            <SecondaryPrice value={unitPrice} currency={currency} labelStart={t('common/withoutTaxPerPc')} />
            <SecondaryPrice value={unitPriceWithTax} currency={currency} labelStart={t('common/withTaxPerPc')} />
          </div>
        )} */}
        <div className={clsx(classes.totalPrice, className)}>
          <PrimaryPrice value={product.priceWithTax} currency={currency} labelStart={t('common/yourPriceWithTax')} />
          <SecondaryPrice value={priceSaleWithTax} currency={currency} labelStart={t('common/basePriceWithTax')} />
        </div>
      </div>
    );
  },
);

export default withThemeProps(themeSettings)(ProductDetailPrice);

// ts-ignore
const PrimaryPrice = withStyles((theme) => ({
  root: {
    ...theme.typography.h6,
    color: theme.palette.text.primary,
  },
  label: {
    ...theme.typography.body2,
    color: theme.palette.text.secondary,
  },
}))(ProductPriceElement) as typeof ProductPriceElement;

const SecondaryPrice = withStyles((theme) => ({
  root: {
    ...theme.typography.body1,
    color: theme.palette.text.primary,
  },
  label: {
    ...theme.typography.caption,
    color: theme.palette.text.secondary,
  },
}))(ProductPriceElement) as typeof ProductPriceElement;
